import { FETCH_PACKAGE_ORDER_LIST_FULFILLED } from "../../constants/packageOrderList";
import { FETCH_PACKAGE_ORDER_DETAIL_FULFILLED } from "../../constants/packageOrderDetail";
import { FETCH_PACKAGE_DELIVERY_RANGES_FULFILLED } from "../../constants/packageDeliveryRanges";
import { FETCH_TRANSFER_ORDER_LIST_FULFILLED } from "../../constants/transferOrderList";
import { FETCH_TRANSFER_ORDER_DETAIL_FULFILLED } from "../../constants/transferOrderDetail";
import { FETCH_SIGNUP_REJECTED } from "../../constants/signup";
import { SIGNIN_SMS_VERIFICATION_FORM_SHOW, FETCH_SMS_REJECTED, SIGNIN_SMS_VERIFICATION_REJECTED } from "../../constants/signinWithSms";
import { FETCH_CARGO_COMPANIES_FULFILLED } from "../../constants/cargoCompanies";
import { FETCH_PERMISSIONS_FULFILLED } from "../../constants/permissions";

import { packageOrderListMapper } from "../../models/packageOrderList";
import { packageOrderDetailMapper } from "../../models/packageOrderDetail";
import { packageDeliveryRangesMapper } from "../../models/packageDeliveryRanges";
import { transferOrderListMapper } from "../../models/transferOrderList";
import { transferOrderDetailMapper } from "../../models/transferOrderDetail";
import { signupRejectedMapper } from "../../models/signupRejected";
import { signInSmsVerificationMapper } from "../../models/signInSmsVerification";
import { signInSmsRejectedMapper } from "../../models/signInSmsRejected";
import { signInSmsVerficiationRejectedMapper } from "../../models/signInSmsVerificationRejected";
import { cargoCompaniesMapper } from "../../models/cargoCompanies";
import { permissionsMapper } from "../../models/permissions";


export default class Mappers {
  constructor() {
    this.bindToModel = this.bindToModel.bind(this);
    this.map = {
      [FETCH_PACKAGE_ORDER_LIST_FULFILLED]: packageOrderListMapper,
      [FETCH_PACKAGE_ORDER_DETAIL_FULFILLED]: packageOrderDetailMapper,
      [FETCH_PACKAGE_DELIVERY_RANGES_FULFILLED]: packageDeliveryRangesMapper,
      [FETCH_TRANSFER_ORDER_LIST_FULFILLED]: transferOrderListMapper,
      [FETCH_TRANSFER_ORDER_DETAIL_FULFILLED]: transferOrderDetailMapper,
      [FETCH_SIGNUP_REJECTED]: signupRejectedMapper,
      [SIGNIN_SMS_VERIFICATION_FORM_SHOW]: signInSmsVerificationMapper,
      [SIGNIN_SMS_VERIFICATION_REJECTED]: signInSmsVerficiationRejectedMapper,
      [FETCH_SMS_REJECTED]: signInSmsRejectedMapper,
      [FETCH_CARGO_COMPANIES_FULFILLED]: cargoCompaniesMapper,
      [FETCH_PERMISSIONS_FULFILLED]: permissionsMapper,
    };
  }

  bindToModel(action) {
    const { map } = this;
    const mapper = map[action.type];
    return mapper
      ? {
          ...action,
          data: mapper(action.data)
        }
      : action;
  }
}



// WEBPACK FOOTER //
// ./src/services/integration/index.js